import React, { memo } from "react";
import { Grid, Tooltip, makeStyles } from "@material-ui/core";
import { Field } from "formik";
import { CheckboxWithLabel } from "formik-material-ui";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CheckBoxOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";

import {
  LEAVE_FROM_SATELLITE_DEPOT_TOOLTIP,
  LOCKDOWN_TOOLTIP,
  RETURN_TO_SATELLITE_DEPOT_TOOLTIP,
} from "../messages";
import palette from "../../../components/styles/palette";
import { View } from "../../../components/Base";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    paddingLeft: "0.5rem",
    paddingBottom: "1.5rem",
  },
  item: {
    display: "flex",
    height: typography.pxToRem(20),
  },
  labelText: {
    fontSize: typography.pxToRem(12),
    lineHeight: typography.pxToRem(20),
    color: palette.typography.black.solid,
  },
  tooltip: {
    color: palette.typography.black.disabled,
    paddingLeft: "0.5rem",
  },
}));

const DriverCheckboxes = ({ isDisabled }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Grid item xs={12} className={styles.item}>
        <Field
          component={CheckboxWithLabel}
          name="saturnLockdown"
          Label={{
            label: <View className={styles.labelText}>Lockdown</View>,
          }}
          type="checkbox"
          disabled={isDisabled}
          checkedIcon={<CheckBoxOutlinedIcon />}
          data-testid="saturn-lockdown"
        />
        <Tooltip
          title={LOCKDOWN_TOOLTIP}
          placement="right-start"
          fontSize="small"
          className={styles.tooltip}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Grid>
      <Grid item xs={12} className={styles.item}>
        <Field
          component={CheckboxWithLabel}
          name="startAtSatellite"
          Label={{
            label: (
              <View className={styles.labelText}>
                Leave From Satellite Depot
              </View>
            ),
          }}
          type="checkbox"
          disabled={isDisabled}
          checkedIcon={<CheckBoxOutlinedIcon />}
          data-testid="start-at-satellite"
        />
        <Tooltip
          title={LEAVE_FROM_SATELLITE_DEPOT_TOOLTIP}
          placement="right-start"
          fontSize="small"
          className={styles.tooltip}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Grid>
      <Grid item xs={12} className={styles.item}>
        <Field
          component={CheckboxWithLabel}
          name="endAtSatellite"
          Label={{
            label: (
              <View className={styles.labelText}>
                Return to Satellite Depot
              </View>
            ),
          }}
          type="checkbox"
          disabled={isDisabled}
          checkedIcon={<CheckBoxOutlinedIcon />}
          data-testid="end-at-satellite"
        />
        <Tooltip
          title={RETURN_TO_SATELLITE_DEPOT_TOOLTIP}
          placement="right-start"
          fontSize="small"
          className={styles.tooltip}
        >
          <InfoOutlinedIcon />
        </Tooltip>
      </Grid>
    </View>
  );
};

export default memo(DriverCheckboxes);
